import * as R from 'ramda';

const updateUserAgreement = () => state => {
    const user = JSON.parse(localStorage.getItem('mvc-user'));
    const updatedUser = R.assoc('agreementsAccepted', true, user);

    localStorage.setItem('mvc-user', JSON.stringify(updatedUser));

    return {
        user: {
            ...state.user,
            agreementsAccepted: true,
        },
    };
};

export default updateUserAgreement;
